import {
  BoardCaseTypeEnum,
  BoardCaseStatusEnum,
  CasesQueryStatusEnum,
  ProposedForEditCaseFilterType,
  ProposedForEditCaseFilterEnum,
} from '../models/BoardCase'
import { IMeetingAgendaModel } from '../models/BoardMeeting'

export const getCaseStatus = (
  status: BoardCaseStatusEnum,
  options?: {
    isCaseList: boolean
  }
) => {
  switch (status) {
    case BoardCaseStatusEnum.New:
      return 'Opprettet'
    case BoardCaseStatusEnum.Ongoing:
      return 'Under behandling'
    case BoardCaseStatusEnum.Completed:
      return 'Avsluttet'
    case BoardCaseStatusEnum.Deleted:
      return 'Slettet'
    case BoardCaseStatusEnum.ForFollowup:
      return 'Til oppfølging'
    case BoardCaseStatusEnum.Postponed:
      if (options?.isCaseList) return 'Opprettet'
      return 'Utsatt'
    default:
      return 'Ukjent'
  }
}

export const getCaseTagColor = (enumStatus: BoardCaseStatusEnum) => {
  switch (enumStatus) {
    case BoardCaseStatusEnum.Postponed:
      return 'info'
    case BoardCaseStatusEnum.Deleted:
      return 'danger'
    case BoardCaseStatusEnum.Completed:
      return 'success'
    default:
      return null
  }
}

export const getMeetingCaseStatus = (
  boardCase: IMeetingAgendaModel,
  options?: {
    forceToProgress: boolean
  }
) => {
  switch (boardCase.status) {
    case BoardCaseStatusEnum.Ongoing:
      return 'Pågår'

    case BoardCaseStatusEnum.Completed:
      return 'Avsluttet'

    case BoardCaseStatusEnum.ForFollowup:
      if (options?.forceToProgress) return 'Pågår'
      return 'Følges opp senere'

    case BoardCaseStatusEnum.Postponed:
      if (options?.forceToProgress) return 'Pågår'
      return 'Utsatt'

    case BoardCaseStatusEnum.Deleted:
      return 'Slettet'

    default:
      return null
  }
}

export const getCaseType = (status: BoardCaseTypeEnum) => {
  switch (status) {
    case BoardCaseTypeEnum.DecisionCase:
      return 'Beslutningssak'
    case BoardCaseTypeEnum.OrientationCase:
      return 'Orienteringssak'
    case BoardCaseTypeEnum.FollowUpCase:
      return 'Oppfølgingssak'
    default:
      return 'Ukjent'
  }
}
export const formatCaseTypeToEnum = (status: string) => {
  switch (status.toLowerCase()) {
    case 'beslutningssak':
      return BoardCaseTypeEnum.DecisionCase
    case 'orienteringssak':
      return BoardCaseTypeEnum.OrientationCase
    case 'oppfølgingssak':
      return BoardCaseTypeEnum.FollowUpCase
    default:
      return BoardCaseTypeEnum.DecisionCase
  }
}

export const getStatusFilterReadable = (value: CasesQueryStatusEnum) => {
  switch (value) {
    case CasesQueryStatusEnum.ActiveCases:
      return 'Aktive saker'
    case CasesQueryStatusEnum.All:
      return 'Vis alle'
    case CasesQueryStatusEnum.Completed:
      return 'Behandlet'
    case CasesQueryStatusEnum.Postponed:
      return 'Utsatte saker'
    case CasesQueryStatusEnum.ForFollowup:
      return 'Saker til oppfølging'

    default:
      return 'Vis alle'
  }
}

export const getStatusFilterEnum = (value: string) => {
  switch (value) {
    case 'Aktive saker':
      return CasesQueryStatusEnum.ActiveCases
    case 'Vis alle':
      return CasesQueryStatusEnum.All
    case 'Behandlet':
      return CasesQueryStatusEnum.Completed
    case 'Utsatte saker':
      return CasesQueryStatusEnum.Postponed
    case 'Saker til oppfølging':
      return CasesQueryStatusEnum.ForFollowup

    default:
      return CasesQueryStatusEnum.All
  }
}

export const getCaseStatusTextWhenPostponedCase = (
  status: BoardCaseStatusEnum
) => {
  if (status === BoardCaseStatusEnum.Postponed) {
    return 'Utsatt i et tidligere møte'
  }

  if (status === BoardCaseStatusEnum.ForFollowup) {
    return 'Følges opp etter tidligere behandling'
  }

  return null
}

export const getProposedCaseStatusType = (
  value: ProposedForEditCaseFilterEnum
): ProposedForEditCaseFilterType => {
  switch (value) {
    case ProposedForEditCaseFilterEnum.all:
      return 'all'
    case ProposedForEditCaseFilterEnum.postponed:
      return 'postponed'
    case ProposedForEditCaseFilterEnum.followup:
      return 'followup'
    default:
      return 'all'
  }
}
